import { transactionClientHttpClient } from "../../../installations/axiosInterfaces";

const addTransactionClient = (companyId, data) => {
  return transactionClientHttpClient.post(`Add/${companyId}`, data);
};

const getIdAndValidateByPhoneNumber = (companyId, phoneNumber) => {
  return transactionClientHttpClient.get(`GetIdAndValidateByPhoneNumber/${companyId}/${phoneNumber}`);
};

const resendClientAccessCode = (companyId, clientId) => {
  return transactionClientHttpClient.get(`AccessCode/resend/${companyId}/${clientId}`);
};

// Spec 000306 - the proof is issued for this company's page.
const validateTransactionClientAccessCode = (clientId, accessCode, companyId) => {
  return transactionClientHttpClient.get(`AccessCode/Validate/${clientId}/${accessCode}`, { params: { companyId } });
};

const transactionClientService = {
  addTransactionClient,
  getIdAndValidateByPhoneNumber,
  resendClientAccessCode,
  validateTransactionClientAccessCode,
};

export default transactionClientService;
